import { DeviceSelectList } from "fleet/view/device/select-list-v2";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getConnDeviceStatus } from "redux-store/connection/selectors";
import { deviceWithStatusSelector } from "redux-store/derivative-selectors";
import { isStoreReady } from "redux-store/selectors";

function mapStateToProps(state) {
  const storesLoaded = isStoreReady(state.global.devices);

  return {
    storesLoaded,
    devices: deviceWithStatusSelector(state),
    deviceStatusOnline: getConnDeviceStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (deviceIds, action, targetVersion) => {
      const apiArgs = { deviceIds, targetVersion };
      return createPromiseApiAction(dispatch, action, apiArgs);
    },
  };
}

const ConnectedSelectPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceSelectList);

export { ConnectedSelectPage };
